/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ limit: NonNullable<unknown> }} Error_Zns_Test_Rate_LimitedInputs */

const vi_error_zns_test_rate_limited = /** @type {(inputs: Error_Zns_Test_Rate_LimitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã gửi thử ${i?.limit} lần trong một giờ. Đợi một lát rồi gửi tiếp.`)
};

/**

* @param {Error_Zns_Test_Rate_LimitedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_test_rate_limited = /** @type {((inputs: Error_Zns_Test_Rate_LimitedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Test_Rate_LimitedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_test_rate_limited(inputs)
});